<template>
  <div class="holder">
    <input
      :id="id"
      :type="type"
      v-model="data"
      class="form-control"
      @input="emmitEvent"
      @keydown="emitKeydown"
      @change="emitChange"
      :aria-labelledby="id+'_label'"
      :maxlength="maxlength"
      :autocomplete="autocomplete"
      :readonly="readonly"
      :step="(type == 'number'?1:null)"
      :pattern="(type == 'number'?'[0-9]*':null)"
    >
    <span class="counter text-muted" v-if="parseInt(maxlength) > 0">{{charactersLeft}}</span>
  </div>
</template>

<script>
import { capitalize } from 'lodash';

export default {
  name: "IcInput",
  props: {
    id: { type: String },
    value: { type: [String, Number] },
    type: { type: String, default: "text" },
    
    v: { type: Object },
    autocomplete: {type:String},
    readonly: {type:Boolean, default: false},
    maxlength: { type: [String,Number], default: null },
    capitalize: 0,
  },
  data() {
    return {
      data: this.value
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = newValue;
      }
    }
  },
  computed: {
    charactersLeft() {
      if(this.type == 'number') return "";
     
        var char = this.data.toString().length,
            limit = parseInt(this.maxlength);
        
        return (char) + " / " + limit + "";
    }
  },
  methods: {
    emmitEvent(event) {
      let value = event.target.value;
      if(this.capitalize){

        value = value.toLowerCase().split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
      }
         

      this.$emit("input", value);
      if (this.v) {
        this.v.$touch();
      }
    },
    emitKeydown(event) {
      this.$emit("keydown", event);
      if (this.v) {
        this.v.$touch();
      }
    },
    emitChange(event) {
      this.$emit("change", event);
      if (this.v) {
        this.v.$touch();
      }
    }
  }
};
</script>

<style>
.holder {
  position: relative;
}
.counter {
  position: absolute;
margin-top: -34px;
right: 10px;
font-size: 70%;
}
</style>
